import { ANNOUNCEMENT_ACTIONS as type } from "@common/constants/actionTypes";
import { getActiveAnnouncements } from "../services/announcementService";

const getAnnouncements = () => ({ type: type.GET_ANNOUNCEMENTS });

const getAnnouncementsSuccess = items => ({
  type: type.GET_ANNOUNCEMENTS_SUCCESS,
  items
});

const getAnnouncementsError = message => ({
  type: type.GET_ANNOUNCEMENTS_ERROR,
  message
});

export const fetchAnnouncements = () => {
  return dispatch => {
    dispatch(getAnnouncements());
    return getActiveAnnouncements()
      .then(items => dispatch(getAnnouncementsSuccess(items)))
      .catch(() => dispatch(getAnnouncementsError("Fetching announcements failed")));
  };
};
